export default __webpack_public_path__ + "static/media/news7.df0afa20.png";